import { Flex, Text } from '@chakra-ui/react'
import { useLocale } from '@/i18n'
import { FOOTER_COPY } from './footer.data'

export const Footer = () => {
  const { locale } = useLocale()
  const footer = FOOTER_COPY[locale]

  return (
    <Flex
      as="footer"
      bg="ink"
      color="neutral.400"
      px="clamp(20px, 4vw, 48px)"
      pt="clamp(24px, 3vw, 32px)"
      pb="clamp(28px, 3.5vw, 40px)"
      gap="32px"
      flexWrap="wrap"
      alignItems="baseline"
    >
      <Text
        fontFamily="heading"
        fontWeight="800"
        fontSize="12px"
        letterSpacing="0.14em"
        textTransform="uppercase"
        color="neutral.100"
      >
        {footer.brandLine}
      </Text>
      <Text fontSize="12px" letterSpacing="0.14em" textTransform="uppercase">
        {footer.locationLine}
      </Text>
      <Text ml={{ base: 0, md: 'auto' }} fontSize="12px" letterSpacing="0.04em">
        {footer.privacyLine}
      </Text>
    </Flex>
  )
}
